import Vue from 'vue'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'
// import enLang from 'element-ui/lib/locale/lang/en'// 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'
import sentry from './sentry'
import { cloneDeep } from 'lodash-es'

import './icons' // icon
import icon from './components/icon'

import '@icon-park/vue/styles/index.css'

import * as filters from './filters' // global filters
import { getUserInfo, getSiteInfo } from './api/login'
import { getAddonList } from './api/addon'

import VPermission from '@/directive/permission'
Vue.use(VPermission)
import VueClipboard from 'vue-clipboard2'
import '@zenweb/grid-vue-element/lib/zengrid.css'
import ZenGrid from '@zenweb/grid-vue-element'
Vue.use(ZenGrid)
Vue.prototype.$c = cloneDeep
Vue.use(sentry)
Vue.component('icon', icon)
Element.Dialog.props.closeOnClickModal.default = false

Vue.use(Element, {
  // size: Cookies.get('size') || 'medium', // set element-ui default size
  size: 'medium' // set element-ui default size
  // locale: enLang // 如果使用中文，无需设置，请删除
})

const screenHeight = window.screen.height
if (screenHeight > 1300) {
  Vue.prototype.$tableHeight = 1000
} else if (screenHeight < 800) {
  Vue.prototype.$tableHeight = 480
} else {
  Vue.prototype.$tableHeight = 550
}
Vue.prototype.$pageSize = 20
Vue.prototype.$pageSizeOptions = [20, 50, 100]

Vue.prototype.$prefix = 'talent-finance/'
// Vue.prototype.$prefix = ''

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

// 注册通用组件
import BaseSearch from '@/components/base/search'
import BaseTable from '@/components/base/table'
Vue.component('BaseSearch', BaseSearch)
Vue.component('BaseTable', BaseTable)

/**
 *  引入复制功能
 */
// 复制没有特定的文本
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

!(async() => {
  const siteInfo = await getSiteInfo()
  const title = siteInfo.data.siteName || ''
  const _siteName = title + '业财系统'
  store.dispatch({
    type: 'login/setSiteName',
    siteName: _siteName
  })
  document.title = _siteName

  const addonList = await getAddonList()
  store.dispatch({
    type: 'login/setAddonCenter',
    addonCenter: addonList.data
  })

  const token = JSON.parse(localStorage.getItem('token'))
  if (token) {
    store.dispatch({
      type: 'login/setToken',
      token: token
    })
    const userInfo = await getUserInfo()
    store.dispatch({
      type: 'login/setUser',
      user: userInfo.data
    })

    await store.dispatch('login/setAllCompany')
    await store.dispatch('login/setPermissionAuth', userInfo.data)
    await store.dispatch('login/setMyBooks', userInfo.data)
    await store.dispatch('login/setRouteAuth')
  }

  new Vue({
    el: '#app',
    router,
    store,
    beforeCreate() {
      Vue.prototype.$bus = this
    },
    render: h => h(App)
  })
})()
